var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// CARE_CHOICES
var CARE_CHOICES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query CareChoices {\n    care_choices {\n      nodes {\n        id\n        name\n        initial\n        recommended\n      }\n    }\n  }\n"], ["\n  query CareChoices {\n    care_choices {\n      nodes {\n        id\n        name\n        initial\n        recommended\n      }\n    }\n  }\n"])));
export var useCareChoicesQuery = function (options) {
    return useQuery(CARE_CHOICES, options);
};
export default CARE_CHOICES;
var templateObject_1;
